import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { catchError, of, tap } from 'rxjs';
import { UserService } from '../services/user.service';
import { UserWithRole } from '../models/user';

export interface CurrentUser {
  currentUser: UserWithRole | null;
}

export const initialUserState: CurrentUser = {
  currentUser: null,
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState<CurrentUser>(initialUserState),
  withMethods((store) => {
    const userService = inject(UserService);
    return {
      setCurrentUser(user: UserWithRole | null) {
        patchState(store, { currentUser: user });
      },

      fetchMe() {
        return userService.fetchMe().pipe(
          tap((user) => {
            patchState(store, { currentUser: user });
          }),
          catchError((error) => {
            console.error('Failed to fetch user', error);
            patchState(store, { currentUser: null });
            return of(null);
          }),
        );
      },

      clear(): void {
        patchState(store, { currentUser: null });
      },
    };
  }),
  withComputed(({ currentUser }) => ({
    isAuthenticated: computed(() => !!currentUser()),
  })),
);
